import { render, staticRenderFns } from "./Juiz.vue?vue&type=template&id=356953e4&scoped=true"
import script from "./Juiz.vue?vue&type=script&lang=js"
export * from "./Juiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356953e4",
  null
  
)

export default component.exports